import PubSub from 'underpub-js';
import gsap from 'gsap';
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

var ExpandableSection = function (options) {
  this.options = {
    $el: false,
    baseClass: 'el-ExpandableSection',
    isToggled: false,
  };

  $.extend(true, this.options, options);
};

ExpandableSection.prototype.init = function () {
  var self = this;

  self.$toggle = self.options.$el.find(
    `.${self.options.baseClass}__toggle`,
  );
  self.$items = self.options.$el.find(`.${self.options.baseClass}__items`);
  self.$toggleIcon = self.options.$el.find(
    `.${self.options.baseClass}__toggle__icon`,
  );
  self.$toggleIconLine = self.$toggleIcon.find('.line');
  self.$toggleIconLineHorizontal = self.$toggleIconLine.filter('.horizontal');
  self.$toggleIconLineVertical = self.$toggleIconLine.filter('.vertical');

  if (self.$items.length && self.$toggle.length) {
    self.initAnimation();
    self.$toggle.on('click', () => self.toggle());
  }

  PubSub.subscribe('ExpandableSection__toggleOff', () => self.toggleOff(100));
};

ExpandableSection.prototype.initAnimation = function () {
  const self = this;

  const getHeightTween = () =>
    gsap.to(self.$items, {
      height: self.options.isToggled ? 0 : 'auto',
      duration: 0.45,
      ease: 'expo.inout',
    });

  self.timeline = gsap
    .timeline({
      paused: true,
      reversed: true,
      onComplete: () => {
        self.toggleState();
        gsap.to(window, {
          scrollTo: {
            y: self.options.$el[0],
            offsetY: 10
          },
          duration: .5,
          ease: 'expo.inout',
        })
      },
      onReverseComplete: () => self.toggleState(),
    })
    .to(self.$toggleIconLineVertical, {
      rotation: 0,
      duration: .3,
      ease: 'expo.inout',
    })
    .to(
      self.$toggleIconLineHorizontal, {
        opacity: 0,
        rotation: 90,
        duration: .3,
        ease: 'expo.inout',
      },
      '<',
    )
    .call(getHeightTween)
    .fromTo(
      self.$items, {
        opacity: 0,
      }, {
        opacity: 1,
        duration: 0.4,
        delay: .1,
        ease: 'expo.inout',
      },
      '<.1',
    );
};

ExpandableSection.prototype.toggleState = function () {
  const self = this;

  self.options.isToggled = !self.options.isToggled;
};

ExpandableSection.prototype.toggleOn = function (speed = 1) {
  const self = this;

  // Close any other open navigation item first
  PubSub.publish("ExpandableSection__toggleOff");

  if (self.options.isToggled || self.timeline.isActive()) return;

  self.timeline.timeScale(speed).play();
};

ExpandableSection.prototype.toggleOff = function (speed = 3) {
  const self = this;

  if (!self.options.isToggled || self.timeline.isActive()) return;

  self.timeline.timeScale(speed).reverse();
};

ExpandableSection.prototype.toggle = function () {
  const self = this;

  self.timeline.reversed() ? self.toggleOn() : self.toggleOff();
};

export default ExpandableSection;